import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const categories = sqliteTable('categories', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  name: text('name'),
  type: text('type'),
  user_id: integer('user_id'),
  organization_id: text('organization_id'),
  is_user_defined: integer('is_user_defined'),
  is_enabled: integer('is_enabled'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
